import React from 'react';
import { ArrowRightIcon, CheckIcon, StarIcon } from 'lucide-react';
import { planes } from '../data/planes';
import { Emoji } from './Emoji';
export function PlanCards() {
  return <ul className="flex flex-col gap-8" data-id="element-163" data-mp="19dq1pe3hsk2j">
      {planes.map(plan => <li key={plan.id} id={`plan-${plan.id}`} className={['relative scroll-mt-8 rounded-3xl p-7 text-center sm:p-8', plan.featured ? 'bg-pistacho shadow-lift ring-4 ring-gold' : 'border border-line bg-pistacho shadow-card'].join(' ')} data-id="element-164" data-mp="19bvflwghilwv">
          {plan.featured ? <span className="absolute -top-3.5 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-gold px-3.5 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-[0.14em] text-forest-950" data-id="element-165" data-mp="1s3y0jk05socx">
              <StarIcon className="h-3 w-3 fill-forest-950" aria-hidden="true" data-id="element-166" data-mp="1x3ka9jgs3mgz" />
              El más elegido
            </span> : null}

          <h3 className="mt-2 inline-flex items-center justify-center gap-2 font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-forest-950 sm:text-2xl" data-id="element-167" data-mp="35xyqysm9ph54">
            <Emoji symbol={plan.emoji} className="text-2xl" data-id="element-168" data-mp="3fts2q9s5x6lu" />
            {plan.name}
          </h3>

          <p className="mx-auto mt-3 max-w-sm text-[15px] font-semibold leading-relaxed text-forest-800" data-id="element-169" data-mp="3jxho6qdjj82n">
            {plan.includes}
          </p>
          <p className="mt-2 text-sm text-forest-600/80" style={{
        fontWeight: "900"
      }} data-id="element-170" data-mp="3otowuqxbmxoa">
            Ideal para: {plan.bestFor}
          </p>

          <p className="mt-6 text-sm text-forest-600/70" data-id="element-171" data-mp="2forflg0qwjp">
            Valor real <span className="line-through" data-id="element-172" data-mp="7f1m2sd4t7wu">{plan.listPrice}</span>
          </p>
          <p className="mt-1 font-display text-4xl font-black leading-none tracking-tight text-forest-950 sm:text-5xl" data-id="element-173" data-mp="7h49r5qtaoye">
            {plan.price}
          </p>
          <p className="mt-2 font-display text-xs font-bold uppercase tracking-[0.16em] text-lime-700" data-id="element-174" data-mp="ggrcpvz6w2tk">
            Precio de lanzamiento
          </p>

          <ul className="mx-auto mt-7 flex max-w-sm flex-col gap-3 text-left" data-id="element-175" data-mp="2cgi4wc8xmq0d">
            {plan.features.map(feature => <li key={feature} className="flex items-start gap-3 text-[15px] text-forest-800" data-id="element-176" data-mp="2m977siqf2vk3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lime-500" data-id="element-177" data-mp="2hgminuigh6mw">
                  <CheckIcon className="h-3 w-3 text-forest-950" strokeWidth={3} aria-hidden="true" data-id="element-178" data-mp="2w8oe92dhtdh4" />
                </span>
                {feature}
              </li>)}
          </ul>

          <a href={plan.checkoutUrl} className={['group mt-8 flex items-center justify-center gap-2 rounded-full px-6 py-4 text-center font-display text-[15px] font-extrabold uppercase tracking-tight transition-[background-color,color,border-color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-600 focus-visible:ring-offset-2 focus-visible:ring-offset-pistacho', plan.featured ? 'cta-latente bg-lime-500 text-forest-950 hover:bg-lime-400' : 'border-2 border-forest-800/25 text-forest-900 hover:border-lime-600 hover:bg-lime-200/50'].join(' ')} data-id="element-179" data-mp="308ymymso6hzo">
            {plan.cta}
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-180" data-mp="2ytmdskvpf1ny" />
          </a>
        </li>)}
    </ul>;
}